<template>
	<Modal v-if="shown"
		   :title="referenceNumber"
		   :close-on-click-outside="false"
		   @close="show(false)"
	>
		<template v-slot:body>
			<div class="flex flex_column modal-content">
				<RevolvingPutOptionShortInfo :option-data="paymentPlan"/>
				<div class="margin_top">
					<h4 class="info_title small_margin">{{$t('revolvingPutOption.paymentPlan')}}</h4>
					<RevolvingPutOptionPremiumPaymentsTable :row-data="paymentPlan.entries"/>
				</div>
			</div>
			<div class="flex flex_end margin_top">
				<md-button class="md-blank" @click.stop="show(false)">{{ $t('common.close') }}</md-button>
			</div>
		</template>
	</Modal>
</template>

<script>

import RevolvingPutOptionShortInfo from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionShortInfo";
import RevolvingPutOptionPremiumPaymentsTable
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionPremiumPaymentsTable";
import Modal from "@/components/templates/modal/Modal";

export default {
	components: {
		Modal,
		RevolvingPutOptionShortInfo,
		RevolvingPutOptionPremiumPaymentsTable
	},
	data() {
		return {
			shown: false,
			referenceNumber: "",
			paymentPlan: {},
		};
	},
	methods: {
		loadPaymentPlan(loadingPromise) {
			this.paymentPlan = {};

			loadingPromise
				.then((res) => {
					this.paymentPlan = res;
				})
				.catch(this.toast);
		},
		show(value) {
			this.shown = value;
		},
		showWithData(referenceNumber, loadingPromise) {
			this.referenceNumber = referenceNumber;
			this.loadPaymentPlan(loadingPromise);
			this.show(true);
		}
	}
};
</script>